export default __webpack_public_path__ + "static/media/pending-and-partial.c25aab27.svg";